import { createSlice } from '@reduxjs/toolkit'

import { RootState } from '..'
import { fetchTrainEquipmentCirculationAction } from '../actions/train-equipment-circulation'
import { generateEquipmentInfoKey } from '../lib/trainEquipmentUtils'
import { ActionStatus, TrainEquipmentCirculation } from '../types/Input'

export interface TrainEquipmentCirculationState {
  status: ActionStatus
  trainEquipmentCirculationByTrain: Record<string, TrainEquipmentCirculation>
  error?: string
}

const initialState: TrainEquipmentCirculationState = {
  status: 'none',
  trainEquipmentCirculationByTrain: {},
}

export const trainEquipmentCirculationSlice = createSlice({
  name: 'train-equipment-circulation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTrainEquipmentCirculationAction.pending, (state) => {
      state.status = 'loading'
      state.error = undefined
    })

    builder.addCase(fetchTrainEquipmentCirculationAction.fulfilled, (state, { payload }) => {
      state.trainEquipmentCirculationByTrain = {
        ...state.trainEquipmentCirculationByTrain,
        [generateEquipmentInfoKey(payload)]: payload,
      }
      state.status = 'succeeded'
    })

    builder.addCase(fetchTrainEquipmentCirculationAction.rejected, (state, { payload }) => {
      if (payload) {
        state.error = payload.message
      }
      state.status = 'failed'
    })
  },
})

export default trainEquipmentCirculationSlice.reducer

export const selectTrainEquipmentCirculationByKey = (state: RootState, key: string) =>
  state.trainEquipmentCirculation.trainEquipmentCirculationByTrain[key]
